/**
 * The file naming the deployed release, written by the build (see `releaseVersionFile` in
 * `vite.config.ts`) and fetched by `useNewReleaseAvailable`.
 *
 * Kept free of imports, as `vite.config.ts` imports it without the app's path aliases.
 */
export const RELEASE_VERSION_FILE = "version.json"
